async function t(t){if(!t)throw new Error("Text to copy to the clipboard can't be undefined");await navigator.clipboard.writeText(t)}export{t as copyToClipboard};
//# sourceMappingURL=clipboard.service.js.map
